export const initialState = {
  popularRecipes: [],
  isLoading: false,
  error: null,
};
